import {createStore, applyMiddleware} from 'redux'
import reducers from './reducers/index'

import logger from 'redux-logger'
import thunk from 'redux-thunk'
const middlewares = [logger]

export default createStore(reducers, applyMiddleware(...middlewares, thunk))
